module.exports = __webpack_public_path__ + "img/calendar.c55ad820.png";